import { useEffect, useState } from 'react';
import { OperacionCorporateLendingDetalle } from '../types/types';
import { QueryStatus } from 'src/types';
import { HttpCorporateLending } from '../api/httpCorporateLending';

export const useDetalle = (idOperacion: number) => {
  const [detalle, setDetalle] = useState<OperacionCorporateLendingDetalle>();
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

  const fetch = () => {
    setStatus(QueryStatus.Loading);

    HttpCorporateLending.getDetalle(idOperacion)
      .then(value => {
        setDetalle(value);
        setStatus(QueryStatus.Success);
      })
      .catch(e => {
        setStatus(QueryStatus.Error);
        console.log(e);
      });
  };

  const refetch = () => fetch();

  useEffect(() => {
    fetch();
  }, [idOperacion]);

  return { detalle, refetch, status };
};